import { render } from "./DocumentCardBatch.vue?vue&type=template&id=5e3f718a"
import script from "./DocumentCardBatch.vue?vue&type=script&lang=js"
export * from "./DocumentCardBatch.vue?vue&type=script&lang=js"
script.render = render

export default script